export const hexToRgbaMap = {
    '#D0ED02': 'rgba(208, 237, 2, 1)',
    '#DFFF00': 'rgba(223, 255, 0, 1)',
    '#E5FF33': 'rgba(229, 255, 51, 1)',
    '#ECFF66': 'rgba(236, 255, 102, 1)',
    '#F2FF99': 'rgba(242, 255, 153, 1)',
    '#F9FFCC': 'rgba(249, 255, 204, 1)',
    '#202133': 'rgba(32, 33, 51, 1)',
    '#363747': 'rgba(54, 55, 71, 1)',
    '#4D4D5C': 'rgba(77, 77, 92, 1)',
    '#797A85': 'rgba(121, 122, 133, 1)',
    '#A6A6AD': 'rgba(166, 166, 173, 1)',
    '#D2D3D6': 'rgba(210, 211, 214, 1)',
    '#F9F8F5': 'rgba(249, 248, 245, 1)',
    '#FAF9F7': 'rgba(250, 249, 247, 1)',
    '#FBFBF9': 'rgba(251, 251, 249, 1)',
    '#FDFCFB': 'rgba(253, 252, 251, 1)',
    '#FEFEFD': 'rgba(254, 254, 253, 1)',
    '#3F6545': 'rgba(63, 101, 69, 1)',
    '#5E9767': 'rgba(94, 151, 103, 1)',
    '#C2FFCF': 'rgba(194, 255, 207, 1)',
    '#C60017': 'rgba(198, 0, 23, 1)',
    '#F8001D': 'rgba(248, 0, 29, 1)',
    '#FF9DA8': 'rgba(255, 157, 168, 1)',
    '#FFDADE': 'rgba(255, 218, 222, 1)',
    '#B84E12': 'rgba(184, 78, 18, 1)',
    '#D1AF56': 'rgba(209, 175, 86, 1)',
    '#FFF6A7': 'rgba(255, 246, 167, 1)',
    '#7B869E': 'rgba(123, 134, 158, 1)',
    '#959EB1': 'rgba(149, 158, 177, 1)',
    '#B0B6C5': 'rgba(176, 182, 197, 1)',
    '#CACFD8': 'rgba(202, 207, 216, 1)',
    '#E5E7EC': 'rgba(229, 231, 236, 1)',
    '#DFEBEE': 'rgba(223, 235, 238, 1)',
    '#47ECD1': 'rgba(71, 236, 209, 1)',
    '#6F4DA1': 'rgba(111, 77, 161, 1)',
    '#8073E5': 'rgba(128, 115, 229, 1)',
    '#327D4F': 'rgba(50, 125, 79, 1)',
    '#20A176': 'rgba(32, 161, 118, 1)',
    '#296A98': 'rgba(41, 106, 152, 1)',
    '#3AA2E8': 'rgba(58, 162, 232, 1)',
    '#CC7A29': 'rgba(204, 122, 41, 1)',
    '#FFA629': 'rgba(255, 166, 41, 1)',
    '#CC4729': 'rgba(204, 71, 41, 1)',
    '#F2683A': 'rgba(242, 104, 58, 1)',
    '#BA065C': 'rgba(186, 6, 92, 1)',
    '#ED0776': 'rgba(237, 7, 118, 1)',
    '#696969': 'rgba(105, 105, 105, 1)',
    '#8A8A8A': 'rgba(138, 138, 138, 1)',
    '#E0E0E0': 'rgba(224, 224, 224, 1)',
    '#A63275': 'rgba(166, 50, 117, 1)',
    '#D94A91': 'rgba(217, 74, 145, 1)',
};

export const hexToColorPrimitiveKey = {
    '#D0ED02': 'brand/yellow/120',
    '#DFFF00': 'brand/yellow/100',
    '#E5FF33': 'brand/yellow/80',
    '#ECFF66': 'brand/yellow/60',
    '#F2FF99': 'brand/yellow/40',
    '#F9FFCC': 'brand/yellow/20',
    '#202133': 'brand/black/100',
    '#363747': 'brand/black/90',
    '#4D4D5C': 'brand/black/80',
    '#797A85': 'brand/black/60',
    '#A6A6AD': 'brand/black/40',
    '#D2D3D6': 'brand/black/20',
    '#F9F8F5': 'brand/white/100',
    '#FAF9F7': 'brand/white/80',
    '#FBFBF9': 'brand/white/60',
    '#FDFCFB': 'brand/white/40',
    '#FEFEFD': 'brand/white/20',
    '#3F6545': 'system/success/500',
    '#5E9767': 'system/success/400',
    '#C2FFCF': 'system/success/200',
    '#C60017': 'system/danger/500',
    '#F8001D': 'system/danger/400',
    '#FF9DA8': 'system/danger/300',
    '#FFDADE': 'system/danger/200',
    '#B84E12': 'system/warning/500',
    '#D1AF56': 'system/warning/400',
    '#FFF6A7': 'system/warning/200',
    '#7B869E': 'secondary/dove/100',
    '#959EB1': 'secondary/dove/80',
    '#B0B6C5': 'secondary/dove/60',
    '#CACFD8': 'secondary/dove/40',
    '#E5E7EC': 'secondary/dove/20',
    '#DFEBEE': 'secondary/soft-gray/100',
    '#47ECD1': 'secondary/aqua/100',
    '#6F4DA1': 'secondary/lavender/500',
    '#8073E5': 'secondary/lavender/400',
    '#327D4F': 'secondary/amazon/500',
    '#20A176': 'secondary/amazon/400',
    '#296A98': 'secondary/steel-blue/500',
    '#3AA2E8': 'secondary/steel-blue/400',
    '#CC7A29': 'secondary/intense-yellow/500',
    '#FFA629': 'secondary/intense-yellow/400',
    '#CC4729': 'secondary/pastel-red/500',
    '#F2683A': 'secondary/pastel-red/400',
    '#BA065C': 'secondary/carmine/500',
    '#ED0776': 'secondary/carmine/400',
    '#696969': 'secondary/dim-gray/500',
    '#8A8A8A': 'secondary/dim-gray/400',
    '#E0E0E0': 'secondary/dim-gray/200',
    '#A63275': 'secondary/max-red-purple/500',
    '#D94A91': 'secondary/max-red-purple/400',
};

export const colorsPrimitives = {
    // Brand / Yellow
    'brand/yellow/20': 'rgba(249, 255, 204, 1)',
    'brand/yellow/40': 'rgba(242, 255, 153, 1)',
    'brand/yellow/60': 'rgba(236, 255, 102, 1)',
    'brand/yellow/80': 'rgba(229, 255, 51, 1)',
    'brand/yellow/100': 'rgba(223, 255, 0, 1)',
    'brand/yellow/120': 'rgba(208, 237, 2, 1)',
    'brand/yellow/100-alpha-50': 'rgba(223, 255, 0, 0.5)',
    // Brand / Black
    'brand/black/20': 'rgba(210, 211, 214, 1)',
    'brand/black/40': 'rgba(166, 166, 173, 1)',
    'brand/black/60': 'rgba(121, 122, 133, 1)',
    'brand/black/80': 'rgba(77, 77, 92, 1)',
    'brand/black/90': 'rgba(54, 55, 71, 1)',
    'brand/black/100': 'rgba(32, 33, 51, 1)',
    'brand/black/100-alpha-50': 'rgba(32, 33, 51, 0.5)',
    'brand/black/100-alpha-70': 'rgba(32, 33, 51, 0.7)',
    'brand/black/80-alpha-60': 'rgba(77, 77, 92, 0.6)',
    'brand/black/80-alpha-40': 'rgba(77, 77, 92, 0.4)',
    'brand/black/80-alpha-10': 'rgba(77, 77, 92, 0.1)',
    // Brand / White
    'brand/white/20': 'rgba(254, 254, 253, 1)',
    'brand/white/40': 'rgba(253, 252, 251, 1)',
    'brand/white/60': 'rgba(251, 251, 249, 1)',
    'brand/white/80': 'rgba(250, 249, 247, 1)',
    'brand/white/100': 'rgba(249, 248, 245, 1)',
    'brand/white/20-alpha-30': 'rgba(254, 254, 253, 0.3)',
    'brand/white/20-alpha-5': 'rgba(254, 254, 253, 0.05)',
    // System / Success
    'system/success/200': 'rgba(194, 255, 207, 1)',
    'system/success/400': 'rgba(94, 151, 103, 1)',
    'system/success/500': 'rgba(63, 101, 69, 1)',
    'system/success/400-alpha-50': 'rgba(94, 151, 103, 0.5)',
    // System / Danger
    'system/danger/200': 'rgba(255, 218, 222, 1)',
    'system/danger/300': 'rgba(255, 157, 168, 1)',
    'system/danger/400': 'rgba(248, 0, 29, 1)',
    'system/danger/500': 'rgba(198, 0, 23, 1)',
    'system/danger/500-alpha-40': 'rgba(198, 0, 23, 0.4)',
    // System / Warning
    'system/warning/200': 'rgba(255, 246, 167, 1)',
    'system/warning/400': 'rgba(209, 175, 86, 1)',
    'system/warning/500': 'rgba(184, 78, 18, 1)',
    'system/warning/500-alpha-50': 'rgba(184, 78, 18, 0.5)',
    // Secondary / Soft-gray
    'secondary/soft-gray/20': 'rgba(249, 251, 252, 1)',
    'secondary/soft-gray/40': 'rgba(242, 247, 248, 1)',
    'secondary/soft-gray/60': 'rgba(236, 243, 245, 1)',
    'secondary/soft-gray/80': 'rgba(229, 239, 241, 1)',
    'secondary/soft-gray/100': 'rgba(223, 235, 238, 1)',
    'secondary/soft-gray/100-alpha-35': 'rgba(223, 235, 238, 0.35)',
    'secondary/soft-gray/100-alpha-25': 'rgba(223, 235, 238, 0.25)',
    // Secondary / Aqua
    'secondary/aqua/20': 'rgba(218, 251, 246, 1)',
    'secondary/aqua/40': 'rgba(181, 247, 237, 1)',
    'secondary/aqua/60': 'rgba(145, 244, 227, 1)',
    'secondary/aqua/80': 'rgba(108, 240, 218, 1)',
    'secondary/aqua/100': 'rgba(71, 236, 209, 1)',
    'secondary/aqua/100-alpha-35': 'rgba(71, 236, 209, 0.35)',
    // Secondary / Dove
    'secondary/dove/20': 'rgba(229, 231, 236, 1)',
    'secondary/dove/40': 'rgba(202, 207, 216, 1)',
    'secondary/dove/60': 'rgba(176, 182, 197, 1)',
    'secondary/dove/80': 'rgba(149, 158, 177, 1)',
    'secondary/dove/100': 'rgba(123, 134, 158, 1)',
    'secondary/dove/100-alpha-35': 'rgba(123, 134, 158, 0.35)',
    // Secondary / Lavender
    'secondary/lavender/200': 'rgba(223, 220, 248, 1)',
    'secondary/lavender/400': 'rgba(128, 115, 229, 1)',
    'secondary/lavender/500': 'rgba(111, 77, 161, 1)',
    'secondary/lavender/400-alpha-35': 'rgba(128, 115, 229, 0.35)',
    // Secondary / Amazon
    'secondary/amazon/200': 'rgba(204, 245, 231, 1)',
    'secondary/amazon/400': 'rgba(32, 161, 118, 1)',
    'secondary/amazon/500': 'rgba(50, 125, 79, 1)',
    'secondary/amazon/400-alpha-35': 'rgba(32, 161, 118, 0.35)',
    // Secondary / Steel-blue
    'secondary/steel-blue/200': 'rgba(205, 230, 246, 1)',
    'secondary/steel-blue/400': 'rgba(58, 162, 232, 1)',
    'secondary/steel-blue/500': 'rgba(41, 106, 152, 1)',
    'secondary/steel-blue/400-alpha-35': 'rgba(58, 162, 232, 0.35)',
    // Secondary / Intense-yellow
    'secondary/intense-yellow/200': 'rgba(249, 219, 192, 1)',
    'secondary/intense-yellow/400': 'rgba(255, 166, 41, 1)',
    'secondary/intense-yellow/500': 'rgba(204, 122, 41, 1)',
    'secondary/intense-yellow/400-alpha-35': 'rgba(255, 166, 41, 0.35)',
    // Secondary / Pastel-red
    'secondary/pastel-red/200': 'rgba(251, 200, 200, 1)',
    'secondary/pastel-red/400': 'rgba(242, 104, 58, 1)',
    'secondary/pastel-red/500': 'rgba(204, 71, 41, 1)',
    'secondary/pastel-red/400-alpha-35': 'rgba(242, 104, 58, 0.35)',
    // Secondary / Carmine
    'secondary/carmine/200': 'rgba(245, 223, 255, 1)',
    'secondary/carmine/400': 'rgba(237, 7, 118, 1)',
    'secondary/carmine/500': 'rgba(186, 6, 92, 1)',
    'secondary/carmine/400-alpha-35': 'rgba(237, 7, 118, 0.35)',
    // Secondary / Dim-gray
    'secondary/dim-gray/200': 'rgba(224, 224, 224, 1)',
    'secondary/dim-gray/400': 'rgba(138, 138, 138, 1)',
    'secondary/dim-gray/500': 'rgba(105, 105, 105, 1)',
    // Secondary / Max-red-purple
    'secondary/max-red-purple/200': 'rgba(254, 214, 234, 1)',
    'secondary/max-red-purple/400': 'rgba(217, 74, 145, 1)',
    'secondary/max-red-purple/500': 'rgba(166, 50, 117, 1)',
    'secondary/max-red-purple/400-alpha-35': 'rgba(217, 74, 145, 0.35)',
};

export const themeColorKeys = [
    'Surface/emphasis',
    'Surface/page',
    'Surface/primary',
    'Surface/section',
    'Surface/secondary',
    'Surface/scrim',
    'Surface/overlay',
    'Surface/Field/hover',
    'Surface/Field/focus',
    'Content/primary',
    'Content/secondary',
    'Content/muted',
    'Content/disabled',
    'Content/inverse',
    'Content/overlay',
    'Accent/primary',
    'Accent/secondary',
    'Accent/logo',
    'Accent/on-accent',
    'Accent/active',
    'Accent/outline',
    'Borders/hover',
    'Borders/active',
    'Borders/quiet',
    'Borders/control',
    'Categorical/1/bg',
    'Categorical/1/emphasis',
    'Categorical/2/bg',
    'Categorical/2/emphasis',
    'Categorical/3/bg',
    'Categorical/3/emphasis',
    'Categorical/4/bg',
    'Categorical/4/emphasis',
    'Categorical/5/bg',
    'Categorical/5/emphasis',
    'Categorical/6/bg',
    'Categorical/6/emphasis',
    'Categorical/7/bg',
    'Categorical/7/emphasis',
    'Categorical/8/bg',
    'Categorical/8/emphasis',
    'Categorical/9/bg',
    'Categorical/9/emphasis',
    'Categorical/10/bg',
    'Categorical/10/emphasis',
    'Status/success/bg',
    'Status/success/content',
    'Status/success/border',
    'Status/danger/bg',
    'Status/danger/content',
    'Status/danger/border',
    'Status/warning/bg',
    'Status/warning/content',
    'Status/warning/border',
    'Status/warning/overlay',
    'Status/neutral/bg',
    'Status/neutral/content',
    'Primitives/success',
    'Primitives/warning',
    'Primitives/gray',
    'Primitives/aqua',
    'Primitives/dove',
] as const;

export type ThemeColorKey = (typeof themeColorKeys)[number];
export type ColorPrimitiveKey = keyof typeof colorsPrimitives;
export type Theme = Record<ThemeColorKey, string>;

const themeConfig: {
    light: Record<ThemeColorKey, ColorPrimitiveKey>;
    dark: Record<ThemeColorKey, ColorPrimitiveKey>;
} = {
    light: {
        'Surface/emphasis': 'brand/black/90',
        'Surface/page': 'brand/white/20',
        'Surface/primary': 'brand/white/20',
        'Surface/section': 'secondary/soft-gray/60',
        'Surface/secondary': 'brand/white/100',
        'Surface/scrim': 'brand/black/100-alpha-50',
        'Surface/overlay': 'brand/black/90',
        'Surface/Field/hover': 'brand/white/40',
        'Surface/Field/focus': 'brand/white/60',
        'Content/primary': 'brand/black/100',
        'Content/secondary': 'brand/black/80',
        'Content/muted': 'brand/black/60',
        'Content/disabled': 'brand/black/40',
        'Content/inverse': 'brand/white/20',
        'Content/overlay': 'brand/white/20',
        'Accent/primary': 'brand/yellow/100',
        'Accent/secondary': 'secondary/aqua/100-alpha-35',
        'Accent/logo': 'brand/black/100',
        'Accent/on-accent': 'brand/black/100',
        'Accent/active': 'brand/yellow/120',
        'Accent/outline': 'brand/yellow/120',
        'Borders/hover': 'brand/black/60',
        'Borders/active': 'brand/black/80',
        'Borders/quiet': 'brand/black/20',
        'Borders/control': 'brand/black/40',
        'Categorical/1/bg': 'secondary/intense-yellow/200',
        'Categorical/1/emphasis': 'secondary/intense-yellow/400',
        'Categorical/2/bg': 'secondary/carmine/200',
        'Categorical/2/emphasis': 'secondary/carmine/400',
        'Categorical/3/bg': 'secondary/max-red-purple/200',
        'Categorical/3/emphasis': 'secondary/max-red-purple/400',
        'Categorical/4/bg': 'secondary/amazon/200',
        'Categorical/4/emphasis': 'secondary/amazon/400',
        'Categorical/5/bg': 'secondary/lavender/200',
        'Categorical/5/emphasis': 'secondary/lavender/400',
        'Categorical/6/bg': 'secondary/aqua/40',
        'Categorical/6/emphasis': 'secondary/aqua/100',
        'Categorical/7/bg': 'secondary/pastel-red/200',
        'Categorical/7/emphasis': 'secondary/pastel-red/400',
        'Categorical/8/bg': 'brand/yellow/40',
        'Categorical/8/emphasis': 'brand/yellow/100',
        'Categorical/9/bg': 'secondary/steel-blue/200',
        'Categorical/9/emphasis': 'secondary/steel-blue/400',
        'Categorical/10/bg': 'secondary/dove/20',
        'Categorical/10/emphasis': 'secondary/dove/100',
        'Status/success/bg': 'system/success/200',
        'Status/success/content': 'system/success/500',
        'Status/success/border': 'system/success/400',
        'Status/danger/bg': 'system/danger/200',
        'Status/danger/content': 'system/danger/500',
        'Status/danger/border': 'system/danger/400',
        'Status/warning/bg': 'system/warning/200',
        'Status/warning/content': 'system/warning/500',
        'Status/warning/border': 'system/warning/400',
        'Status/warning/overlay': 'system/warning/500',
        'Status/neutral/bg': 'secondary/soft-gray/100',
        'Status/neutral/content': 'secondary/dove/100',
        'Primitives/success': 'system/success/200',
        'Primitives/warning': 'system/warning/200',
        'Primitives/gray': 'secondary/soft-gray/100',
        'Primitives/aqua': 'secondary/aqua/20',
        'Primitives/dove': 'secondary/dove/100',
    },
    dark: {
        'Surface/emphasis': 'brand/black/90',
        'Surface/page': 'brand/black/100',
        'Surface/primary': 'brand/black/80-alpha-10',
        'Surface/section': 'brand/white/20-alpha-5',
        'Surface/secondary': 'brand/black/90',
        'Surface/scrim': 'brand/black/100-alpha-70',
        'Surface/overlay': 'brand/black/80',
        'Surface/Field/hover': 'brand/black/90',
        'Surface/Field/focus': 'brand/black/80-alpha-60',
        'Content/primary': 'brand/white/20',
        'Content/secondary': 'brand/black/20',
        'Content/muted': 'brand/black/40',
        'Content/disabled': 'brand/black/60',
        'Content/inverse': 'brand/black/100',
        'Content/overlay': 'brand/white/20',
        'Accent/primary': 'brand/yellow/100',
        'Accent/secondary': 'secondary/aqua/100-alpha-35',
        'Accent/logo': 'brand/yellow/100',
        'Accent/on-accent': 'brand/black/100',
        'Accent/active': 'brand/yellow/120',
        'Accent/outline': 'brand/yellow/120',
        'Borders/hover': 'brand/black/80',
        'Borders/active': 'brand/black/60',
        'Borders/quiet': 'brand/black/80-alpha-60',
        'Borders/control': 'brand/black/80',
        'Categorical/1/bg': 'secondary/intense-yellow/400-alpha-35',
        'Categorical/1/emphasis': 'secondary/intense-yellow/400',
        'Categorical/2/bg': 'secondary/carmine/400-alpha-35',
        'Categorical/2/emphasis': 'secondary/carmine/400',
        'Categorical/3/bg': 'secondary/max-red-purple/400-alpha-35',
        'Categorical/3/emphasis': 'secondary/max-red-purple/400',
        'Categorical/4/bg': 'secondary/amazon/400-alpha-35',
        'Categorical/4/emphasis': 'secondary/amazon/400',
        'Categorical/5/bg': 'secondary/lavender/400-alpha-35',
        'Categorical/5/emphasis': 'secondary/lavender/400',
        'Categorical/6/bg': 'secondary/aqua/100-alpha-35',
        'Categorical/6/emphasis': 'secondary/aqua/100',
        'Categorical/7/bg': 'secondary/pastel-red/400-alpha-35',
        'Categorical/7/emphasis': 'secondary/pastel-red/400',
        'Categorical/8/bg': 'brand/yellow/100-alpha-50',
        'Categorical/8/emphasis': 'brand/yellow/100',
        'Categorical/9/bg': 'secondary/steel-blue/400-alpha-35',
        'Categorical/9/emphasis': 'secondary/steel-blue/400',
        'Categorical/10/bg': 'secondary/dove/100-alpha-35',
        'Categorical/10/emphasis': 'secondary/dove/100',
        'Status/success/bg': 'system/success/400-alpha-50',
        'Status/success/content': 'system/success/200',
        'Status/success/border': 'system/success/400-alpha-50',
        'Status/danger/bg': 'system/danger/500-alpha-40',
        'Status/danger/content': 'system/danger/300',
        'Status/danger/border': 'system/danger/500-alpha-40',
        'Status/warning/bg': 'system/warning/500-alpha-50',
        'Status/warning/content': 'system/warning/200',
        'Status/warning/border': 'system/warning/500-alpha-50',
        'Status/warning/overlay': 'system/warning/500',
        'Status/neutral/bg': 'secondary/soft-gray/100-alpha-25',
        'Status/neutral/content': 'secondary/dove/20',
        'Primitives/success': 'system/success/200',
        'Primitives/warning': 'system/warning/200',
        'Primitives/gray': 'secondary/soft-gray/100',
        'Primitives/aqua': 'secondary/aqua/20',
        'Primitives/dove': 'secondary/dove/100',
    },
};

const resolveTheme = (
    modeConfig: Record<ThemeColorKey, ColorPrimitiveKey>,
    primitives: typeof colorsPrimitives,
): Theme => {
    const resolved = {} as Theme;
    (Object.keys(modeConfig) as ThemeColorKey[]).forEach((key) => {
        const alias = modeConfig[key];
        resolved[key] = primitives[alias];
    });
    return resolved;
};

export const lightTheme: Theme = resolveTheme(themeConfig.light, colorsPrimitives);
export const darkTheme: Theme = resolveTheme(themeConfig.dark, colorsPrimitives);

export const themes: Record<'light' | 'dark', Theme> = {
    light: lightTheme,
    dark: darkTheme,
};
